// extracted by mini-css-extract-plugin
export default {"controls":"MegaMenu__controls___oLPWR","menu":"MegaMenu__menu___aRsoV","hidden":"MegaMenu__hidden___F8Pgx"};